import PATHS, {
  APPLICATION_SUBMISSION_PATHS,
  BEFORE_YOU_GO_PATHS,
  CREDIT_CRIMINAL_CHECK_PATHS,
  IDENTIFYING_DETAILS_PATHS,
} from 'constants/paths';
import SECTION_NAMES from 'constants/sectionNames';
import useBaseURL from 'hooks/useBaseURL';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useHouseholdMembersContext } from 'contexts/HouseholdMembersContext';

const useUnInvitedSecondaryUserRouteManager = ({
  sectionsProgress,
  isSectionsProgressInitialized,
}) => {
  const history = useHistory();
  const baseURL = useBaseURL();

  const { isUnInvitedSecondaryUser, hasData } = useHouseholdMembersContext();

  const {
    [SECTION_NAMES.IDENTIFYING_DETAILS]: identifyingDetailsProgress,
    [SECTION_NAMES.CREDIT_CRIMINAL_CHECK]: creditCriminalCheckProgress,
    [SECTION_NAMES.APPLICATION_SUBMISSION]: applicationSubmissionProgress,
    [SECTION_NAMES.BEFORE_YOU_GO]: beforeYouGoProgress,
  } = sectionsProgress;

  useEffect(() => {
    if (!isSectionsProgressInitialized || !isUnInvitedSecondaryUser || !hasData)
      return;

    const allStepsComplete =
      identifyingDetailsProgress?.isComplete &&
      creditCriminalCheckProgress?.isComplete &&
      applicationSubmissionProgress?.isComplete &&
      beforeYouGoProgress?.isComplete;

    if (!allStepsComplete) {
      if (!identifyingDetailsProgress?.isComplete) {
        return history.push(
          `${baseURL}/${PATHS.IDENTIFYING_DETAILS}/${IDENTIFYING_DETAILS_PATHS.IDENTIFICATION}`,
        );
      }
      if (!creditCriminalCheckProgress?.isComplete) {
        return history.push(
          `${baseURL}/${PATHS.CREDIT_CRIMINAL_CHECK}/${CREDIT_CRIMINAL_CHECK_PATHS.CONSENT}`,
        );
      }
      if (!applicationSubmissionProgress?.isComplete) {
        return history.push(
          `${baseURL}/${PATHS.APPLICATION_SUBMISSION}/${APPLICATION_SUBMISSION_PATHS.SIGNATURE_AND_REPRESENTATION}`,
        );
      }
      if (!beforeYouGoProgress?.isComplete) {
        return history.push(
          `${baseURL}/${PATHS.BEFORE_YOU_GO}/${BEFORE_YOU_GO_PATHS.VOLUNTARY_SELF_IDENTIFICATION}`,
        );
      }
    }
  }, [
    baseURL,
    history,
    isUnInvitedSecondaryUser,
    identifyingDetailsProgress,
    creditCriminalCheckProgress,
    applicationSubmissionProgress,
    beforeYouGoProgress?.isComplete,
    beforeYouGoProgress,
    sectionsProgress,
    isSectionsProgressInitialized,
    hasData,
  ]);
};

export default useUnInvitedSecondaryUserRouteManager;
